module.exports = __webpack_public_path__ + "img/202501160101.0182d202.png";